import { useContext } from "react";

import { ConsolePageContext } from "pages/[tenant]/console/context/ConsolePage";

export const useConsolePageContext = () => {
  return useContext(ConsolePageContext);
};
